import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs';
import { AuthService } from './auth.service';

export interface ProcessCreateModelLike {
  description: string;
  coordinateSystemId: number;
  fileURL: string;
  fileName: string;
  idTipoCarregamento: number
}

@Injectable()
export class LoadProcessService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  createProcess(model: ProcessCreateModelLike) {
    return this.authService.getAuthInfo().pipe(
      mergeMap((authInfo) => {
        const obj = Object.assign({}, model, {
          userId: authInfo?.userId,
          entityId: authInfo?.entityId,
        });

        return this.http.post<any>(`~LoadProcess/Create`, obj);
      })
    );
  }
}
